// grab whatever Some.js is exporting by default, and export it under the name Some;
export { default as Home } from './Home';
export { default as Blog } from './Blog';
export { default as Message } from './Message';
